window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    
  const sections = gsap.utils.toArray(
    ".klima-anim-section_side-image-or-video"
  );

  sections.forEach((section, i) => {
    const sideImage = section.querySelector(".klima-side-image");
    const sideVideo = section.querySelector(".klima-side-video");
    const popupNotification = section.querySelector(".image-pop-up");
    const pill = section.querySelector(".klima-pill");
    const paragraph = section.querySelectorAll(".klima-text, h3");
    const quotePopups = section.querySelectorAll(".image_google-home-quote");

    // split header words into separate spans for staggered animation
    const header = section.querySelector("h2");
    const headerWords = header.innerHTML.split(" ");
    header.innerHTML = headerWords
      .map((word) => {
        return `<span>${word} </span>`;
      })
      .join("");

    const headerWordSpans = header.querySelectorAll("span");

    let start = "top 100%";
    if (i === 0) {
      start = "top 70%";
    }

    let tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: start },
    });
    const mm = gsap.matchMedia();
    mm.add("(max-width: 767px)", () => {
      tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          end: "bottom 40%",
          delay: 0,
        },
      });
      tl.fromTo(
        sideImage,
        { clipPath: "inset(100% 0 0 0 round 28px)" },
        {
          clipPath: "inset(0% 0% 0% 0%)",
          duration: 0.4,
          delay: 0,
        }
      );
      {
        sideVideo &&
          tl.fromTo(
            sideVideo,
            { clipPath: "inset(100% 0 0 0 round 28px)" },
            {
              clipPath: "inset(0% 0% 0% 0%)",
              duration: 0.4,
              delay: 0,
              onStart: () => {
                const video = sideVideo.querySelector("video");
                video?.play();
              },
            }
          );
      }
    });
    mm.add("(min-width: 768px)", () => {
      tl.fromTo(
        sideImage,
        { clipPath: "inset(100% 0 0 0 round 60px)" },
        {
          clipPath: "inset(0% 0% 0% 0%)",
          duration: 0.6,
          ease: "power3.out",
          delay: 0,
        }
      );
      {
        sideVideo &&
          tl.fromTo(
            sideVideo,
            { clipPath: "inset(100% 0% 0% 0% round 60px)" },
            {
              clipPath: "inset(0% 0% 0% 0%)",
              duration: 0.6,
              delay: 0,
              ease: "power3.out",
              onStart: () => {
                const video = sideVideo.querySelector("video");
                video?.play();
              },
            }
          );
      }
    });

    {
      quotePopups.length &&
        tl.fromTo(
          quotePopups,
          { y: 10, opacity: 0 },
          {
            duration: 0.3,
            stagger: 0.2,
            opacity: 1,
            y: 0,
          },
          ">"
        );
    }
    {
      popupNotification &&
        tl.fromTo(
          popupNotification,
          { y: 40, opacity: 0 },
          {
            duration: 0.6,
            opacity: 1,
            y: 0,
            ease: "power3.out",
          },
          "<0.2"
        );
    }
    tl.fromTo(
      pill,
      { y: 16, opacity: 0 },
      {
        duration: 0.4,
        opacity: 1,
        y: 0,
        ease: "power3.out",
      },
      `${quotePopups.length ? ">" : "<0.4"}`
    );
    tl.fromTo(
      headerWordSpans,
      { clipPath: "inset(100% 0% 0% 0%)" },
      {
        duration: 0.6,
        clipPath: "inset(0% 0% 0% 0%)",
        ease: "power3.out",
        stagger: 0.05,
      },
      "<"
    );
    tl.fromTo(
      paragraph,
      { y: 100, opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        y: 0,
        ease: "power3.out",
        stagger: 0.2,
      },
      "<0.2"
    );
  });
  }, 500)
    
});
